// EditProfilePage.jsx
import React, { useState, useEffect, useContext } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  FaUser,
  FaCamera,
  FaArrowLeft,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
} from "react-icons/fa";
import "../../../../assets/css/customer/subscreens/account/EditProfile.css";
import AppContext from "../../../../contexts/AppContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyNavbar from "../../../../components/general/mynavbar/MyNavbar";

const EditProfilePage = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles, setCustomer,customerAuthToken } = useContext(AppContext);

  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [customerId, setCustomerId] = useState(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [imageForEdit, setImageForEdit] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const viewProfile = (customer) => {
    setLoading(true);

    const id = customer?.id;

    const formdata = new FormData();
    formdata.append("customer_id", id);

    axios
      .post(`${baseUrl}/customer/viewProfile`, formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${customerAuthToken}`,
        },
      },
    )
      .then((response) => {
        console.log(response.data);

        if (response.data.success) {
          const data = response.data.customer;

          setProfileData(data);
          setFirstName(data.first_name);
          setLastName(data.last_name);
          setEmail(data.email);
          setPhoneNumber(data.phone_number);
          setAddress(data.address);
          setCity(data.city);
          setPostalCode(data.postal_code);
          setCustomerId(data.id);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const updateProfile = () => {
    console.log(JSON.parse(localStorage.getItem("loggedInCustomer")));
    setSubmitLoading(true);

    const customer = JSON.parse(localStorage.getItem("loggedInCustomer"));
    const id = customer?.id;

    const formdata = new FormData();
    formdata.append("customer_id", id);
    formdata.append("first_name", firstName);
    formdata.append("last_name", lastName);
    formdata.append("email", email);
    formdata.append("phone_number", phoneNumber);
    formdata.append("address", address);
    formdata.append("city", city);
    formdata.append("postal_code", postalCode);

    if (profileImage) {
      formdata.append("profile_image", profileImage);
    }

    axios
      .post(`${baseUrl}/customer/profile/updateProfile`, formdata, {
        headers: { "Content-Type": "multipart/form-data" ,
           "Authorization": `Bearer ${customerAuthToken}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          toast.success("Profile Updated Successfully");

          const updatedCustomer = response.data.customer;

          if (updatedCustomer) {
            localStorage.setItem(
              "loggedInCustomer",
              JSON.stringify(updatedCustomer),
            );
            setCustomer(updatedCustomer);
            viewProfile(updatedCustomer);
            setTimeout(() => {
              navigate("/account");
            }, 1500);
          }
        }

        setSubmitLoading(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Profile update failed. Please try again.");
        setSubmitLoading(false);
      });
  };

  const resetForm = () => {
    setCustomerId(null);
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhoneNumber("");
    setAddress("");
    setCity("");
    setPostalCode("");
    setProfileImage(null);
    setImageForEdit("");
    setErrorMessage("");
  };

  useEffect(() => {

    
    const customer = JSON.parse(localStorage.getItem("loggedInCustomer"));
    viewProfile(customer);
  }, []);

  return (
    <>
      <MyNavbar />
      <div className="account-edit-profile-page">
        <ToastContainer />
        <Container>
          <div className="account-account-shell-container">
            <div className="account-edit-header">
              <button
                className="account-back-button"
                onClick={() => navigate("/account")}
              >
                <FaArrowLeft size={20} />
              </button>
              <h1>Edit Profile</h1>
              <div></div>
            </div>

            {/* Profile Image Section */}
            <Card className="account-profile-image-card">
              <div className="account-profile-image-container">
                <div className="account-profile-image-wrapper">
                  {profileData?.profile_image ? (
                    <img
                      src={
                        profileData?.profile_image?.includes("customer")
                          ? `${baseUrlForFiles}/${profileData.profile_image}`
                          : profileData.profile_image
                      }
                      style={{ height: 100, width: 100 }}
                      alt="Profile"
                      className="account-edit-profile-image"
                    />
                  ) : (
                    <div className="account-edit-profile-image account-profile-placeholder-edit">
                      <FaUser size={50} />
                    </div>
                  )}
                  <label htmlFor="profile-upload" className="account-camera-button">
                    <FaCamera size={18} />
                    <input
                      type="file"
                      id="profile-upload"
                      accept="image/*"
                      onChange={(e) => {
                        setProfileImage(e.target.files[0]);

                        const reader = new FileReader();
                        reader.onload = () => {
                          setProfileData({
                            ...profileData,
                            profile_image: reader.result,
                          });
                        };
                        reader.readAsDataURL(e.target.files[0]);
                      }}
                      style={{ display: "none" }}
                    />
                  </label>
                </div>
                <p className="account-upload-hint">Click camera icon to change photo</p>
              </div>
            </Card>

            {/* Edit Form */}
            <Form>
              <Card className="account-form-card">
                <h3 className="account-form-section-title">Personal Information</h3>

                <div className="account-form-row">
                  <Form.Group className="account-form-account-group-half">
                    <Form.Label>First Name</Form.Label>
                    <div className="account-input-with-icon">
                      <FaUser className="account-input-icon" />
                      <Form.Control
                        type="text"
                        name="firstName"
                        value={firstName}
                        onChange={(e) => {
                          setFirstName(e.target.value);
                          setErrorMessage("");
                        }}
                        placeholder="Enter first name"
                        required
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="account-form-account-group-half">
                    <Form.Label>Last Name</Form.Label>
                    <div className="account-input-with-icon">
                      <FaUser className="account-input-icon" />
                      <Form.Control
                        type="text"
                        name="lastName"
                        value={lastName}
                        onChange={(e) => {
                          setLastName(e.target.value);
                        }}
                        placeholder="Enter last name"
                        required
                      />
                    </div>
                  </Form.Group>
                </div>

                <Form.Group className="account-form-account-group">
                  <Form.Label>Email Address</Form.Label>
                  <div className="account-input-with-icon">
                    <FaEnvelope className="account-input-icon" />
                    <Form.Control
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      placeholder="Enter email"
                      required
                    />
                  </div>
                </Form.Group>

                <Form.Group className="account-form-account-group">
                  <Form.Label>Phone Number</Form.Label>
                  <div className="account-input-with-icon">
                    <FaPhone className="account-input-icon" />
                    <Form.Control
                      type="tel"
                      name="phoneNumber"
                      value={phoneNumber}
                      onChange={(e) => {
                        setPhoneNumber(e.target.value);
                      }}
                      placeholder="Enter phone number"
                      required
                    />
                  </div>
                </Form.Group>
              </Card>

              <Card className="account-form-card">
                <h3 className="account-form-section-title">Address Information</h3>

                <Form.Group className="account-form-account-group">
                  <Form.Label>Street Address</Form.Label>
                  <div className="account-input-with-icon">
                    <FaMapMarkerAlt className="account-input-icon" />
                    <Form.Control
                      type="text"
                      name="address"
                      value={address}
                      onChange={(e) => {
                        setAddress(e.target.value);
                      }}
                      placeholder="Enter street address"
                    />
                  </div>
                </Form.Group>

                <div className="account-form-row">
                  <Form.Group className="account-form-account-group-half">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      name="city"
                      value={city}
                      onChange={(e) => {
                        setCity(e.target.value);
                      }}
                      placeholder="Enter city"
                    />
                  </Form.Group>

                  <Form.Group className="account-form-account-group-half">
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      type="text"
                      name="postalCode"
                      value={postalCode}
                      onChange={(e) => {
                        setPostalCode(e.target.value);
                        setErrorMessage("");
                      }}
                      placeholder="Enter postal code"
                    />
                  </Form.Group>
                </div>
              </Card>

              {/* Action Buttons */}
              <div className="account-action-buttons">
                <Button
                  type="button"
                  className="account-cancel-button"
                  onClick={() => navigate("/account")}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  className="account-save-button"
                  disabled={submitLoading}
                  onClick={updateProfile}
                >
                  {submitLoading ? "Updating..." : "Save Changes"}
                </Button>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    </>
  );
};

export default EditProfilePage;